import { apiUrl } from '../config/api';
import { Capacitor } from '@capacitor/core';

// Wrapper for fetch that handles API URLs correctly for mobile/web
export async function apiFetch(path: string, options?: RequestInit): Promise<Response> {
  const url = apiUrl(path);
  
  console.log('[API Client] Making request to:', url);
  
  // Add default headers
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    ...options?.headers,
  };
  
  try {
    const response = await fetch(url, {
      ...options,
      headers,
      // Don't include credentials for cross-origin requests on mobile
      credentials: Capacitor.isNativePlatform() ? 'omit' : 'include',
    });
    
    console.log('[API Client] Response:', response.status, response.statusText);
    return response;
  } catch (error) {
    console.error('[API Client] Request failed:', error);
    throw error;
  }
}

// Helper for authenticated requests
export async function authenticatedFetch(path: string, token: string, options?: RequestInit): Promise<Response> {
  return apiFetch(path, {
    ...options,
    headers: {
      'Authorization': `Bearer ${token}`,
      ...options?.headers,
    },
  });
}